import { AgencyUnpaidDetailsResponse } from '@cp-mx/common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-19/frontend-integration';
import { fetchUnpaidBalance } from './UnpaidBalanceSlice';
import { UnpaidBalanceDataSelector } from './UnpaidBalanceDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';

export function useUnpaidBalance(): AbstractDataState<AgencyUnpaidDetailsResponse, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchUnpaidBalance, UnpaidBalanceDataSelector);
}
